// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation } from "redux-query-react";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { FundInvestorPairToJSON, TenantPrivateBenchmarkFromJSON, TenantPrivateBenchmarkToJSON, } from '../models';
/**
 * Delete Tenant Private Benchmarks
 */
export function deleteTenantPrivateBenchmarksRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/tenant-private-benchmarks` + queryString,
        meta,
        update: requestConfig.update || {
            TenantPrivateBenchmarks: (prevValue, transformedValue) => {
            }
        },
        optimisticUpdate: requestConfig.optimisticUpdate || {
            TenantPrivateBenchmarks: (prevValue) => {
            }
        },
        rollback: requestConfig.rollback || {
            TenantPrivateBenchmarks: (initialValue, currentValue) => {
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'DELETE',
            headers: headerParameters,
        },
        body: requestParameters.fundInvestorPair?.map(FundInvestorPairToJSON),
    };
    config.queryKey = requestConfig.queryKey || `DeleteTenantPrivateBenchmarks-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Delete Tenant Private Benchmarks
*/
export function deleteTenantPrivateBenchmarks(requestParameters, requestConfig) {
    return deleteTenantPrivateBenchmarksRaw(requestParameters, requestConfig);
}
/**
 * Save Tenant Private Benchmarks
 */
export function postTenantPrivateBenchmarksRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/tenant-private-benchmarks` + queryString,
        meta,
        update: requestConfig.update || {
            TenantPrivateBenchmarks: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: requestParameters.tenantPrivateBenchmark?.map(TenantPrivateBenchmarkToJSON),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(TenantPrivateBenchmarkFromJSON);
            return {
                TenantPrivateBenchmarks: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `PostTenantPrivateBenchmarks-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Save Tenant Private Benchmarks
*/
/**
 * Mutation hook to upsert an Array<TenantPrivateBenchmark>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an Array<TenantPrivateBenchmark>
 */
export const usePostTenantPrivateBenchmarks = (customQueryConfig) => {
    return useMutation((tenantPrivateBenchmark, customQueryParam) => postTenantPrivateBenchmarksRaw({ tenantPrivateBenchmark }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postTenantPrivateBenchmarks(requestParameters, requestConfig) {
    return postTenantPrivateBenchmarksRaw(requestParameters, requestConfig);
}
